module.exports = __webpack_public_path__ + "static/media/img_1.f81efe13.png";